import React, { useEffect, useState } from 'react'
import ActionBar from '../../actionBar'
import NewTaskDialog from '../AddNewTask/newTaskDialog'
import TaskTable from './TaskTable'
import { fetchTasksList } from '../../../backend/backendApis'
import HttpService from '../../../backend/requestApis'
import { Padding } from '@mui/icons-material'
import { Box } from '@mui/material'
import { useDispatch } from 'react-redux'
import { showSnackBar } from '../../CustomComponents/CustomComponentsSlice'
import Loader from '../../Loader'
import { useNavigate } from 'react-router-dom'

const TaskDashboard = () => {

  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [taskDialogStatus, setTaskDialogStatus] = useState(false)
  const [refreshtable, setRefreshTable] = useState(false)
  const [page, setPage] = useState(1)
  const [offset, setOffset] = useState(10)
  const [tableData, setTableData] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  const updateTaskDialogStatus = ((value, refresh = false) => {
    setTaskDialogStatus(value)
    if( refresh){
      setRefreshTable(() => !refreshtable)
    }
  })

  const updatePage = (value) => {
    setPage(() => value)
    setRefreshTable(() => !refreshtable)
  }

  const updateOffset = (value) => {
    setOffset(() => value)
    setRefreshTable(() => !refreshtable)
  }

  useEffect(() => {
    setIsLoading(() => true)
    let options = {
      url: fetchTasksList,
      method: 'GET',
      params: {
        page: page,
        offset: offset
      },
      headers: {
        Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : null
      }
    }

    HttpService(options).then((resp) => {
      setTableData(() => resp?.data?.data)
      setIsLoading(() => false)
    }).catch(err => {
      if (err?.status === 403) {
					localStorage.clear()
          setIsLoading(false)  
					navigate('/login')
				} else {
          console.log('Error in fetching Table Data: ', err)
          setIsLoading(() => false)
          dispatch(showSnackBar({message: 'Error in fetching Table Data. Please Contact Support.'}))
        }
    })

  }, [refreshtable])

  return (
    <>
        <ActionBar dashboard = 'task'
          updateTaskDialogStatus = {updateTaskDialogStatus}
        ></ActionBar>
        <Box style={{padding: '0rem 0.5rem 0rem 0.5rem'}}>
          {isLoading && <Loader></Loader>}
          <TaskTable pageValue={page}
            offsetValue= {offset} data={tableData}
            updatePage= {updatePage}
            updateOffset = {updateOffset}
          >
          </TaskTable>
        </Box>


        <NewTaskDialog dialogStatus={taskDialogStatus} updateDialogStatus={updateTaskDialogStatus}></NewTaskDialog>
    </>
  )
}

export default TaskDashboard
